<div class="container-fluid position-relative d-flex flex-column h-100" *ngIf="!isLoading">
  <div class="row flex-lg-grow-1 align-items-start">

<!------------------  LEFT PART  ------------------>
    <div class="col-5 offset-1 px-4 mb-0 d-flex flex-column">
      <!--   menu à venir   -->

      <!--  formulaire    -->
      <app-user-informations [user]="user" [btnConfig]="{name: 'Modifier l\'utilisateur', btnIcon: 'download_done'}"></app-user-informations>
    </div>

    <!------------------  RIGHT PART  ------------------>
    <div class="offset-1 col-4 pt-3 sticky-top d-flex flex-column gap-24">

      <!--  user basic infos    -->
      <app-basic-informations [user]="user" [type]="'user'"></app-basic-informations>

      <!--  infos in tiles    -->
      <app-bordered-tiles-informations [data]="userBoxInfos"></app-bordered-tiles-informations>

      <!--  documents    -->
      <div class="flex-grow-1 overflow-hidden d-flex flex-column">
        <h6 class="fw-bold d-flex gap-16 align-items-center">
        <span class="bg-grad-blue rounded-circle d-block aspect-ratio_1-1 d-flex align-items-center justify-content-center">
          <span class="material-icons-outlined text-white">sticky_note_2</span>
        </span>
          Documents
        </h6>
        <div class="flex-grow-1 overflow-auto d-flex flex-column gap-16 hidden-scrollbar">
          <app-doc-management *ngFor="let doc of user.documents" [doc]="doc" [reload]="true" (isDeleted)="deleteDocument($event)"></app-doc-management>
        </div>
      </div>



      <!--  informations spé   -->
      <div class="mt-auto" *ngIf="user">
        <p> Inscrit le
          <strong>{{ user.created_at | date:'longDate':'':'FR' }}</strong>
        </p>
        <p> Dernière activité le
          <strong>{{ user.updated_at | date:'longDate':'':'FR' }}</strong>
        </p>
        <p> Agent de l'utilisateur
          <strong>{{ user.agent? (user.agent.lastname + ' ' + user.agent.firstname) : 'Aucun agent assigné' }}</strong>
        </p>
        <p>
          <span *ngIf="!loadingMail" (click)="getUserReservationMail()" class="btn btn-link">Voir le mail du dossier</span>
          <span *ngIf="loadingMail"><div class="spinner-border text-primary"></div></span>          
        </p>
        <p class="mt-2">
          <button *ngIf="!adminPass && !loadingPass" (click)="generateAdminPass()" class="btn btn-primary btn-sm">
            Générer un pass de connexion
          </button>
          <button *ngIf = "!adminPass && loadingPass" class="btn btn-primary btn-sm" type="button" disabled>
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            Loading...
          </button>
          <span *ngIf="adminPass">Vous pouvez copier et utiliser la clé suivante : <b>{{adminPass}}</b></span>
        </p>
      </div>

    </div>


  </div>
</div>

<!-------------------------------------------  loader ----------------------------------------->
<div class="flex-grow-1 d-flex align-items-center justify-content-center mb-5 h-100" *ngIf="isLoading">
  <div class="spinner-border text-primary"></div>
</div>

<ng-template #modal let-modal>

  <div class="modal-container p-3">
    <h4 class="text-primary fw-bold mb-4">Email du dossier</h4>
    <div class="d-flex p-2 m-auto">
      <div [innerHtml]="bookingMail"></div>
    </div>
  </div>
</ng-template>